module.exports = __webpack_public_path__ + "static/media/plant.417ff144.jpg";